<template lang="pug">
li.list-group-item.placement
  slot
  CheckboxIcon(:checked="!!(issueId || pageId)")
  |
  |
  strong(v-if="issueId || pageId") {{ publicationName }}
  span.text-muted(v-else) None selected
  |
  |
  template(v-if="issueId")
    i.fa.fa-angle-right
    |
    |
    i.fa.fa-newspaper-o
    |
    | {{ issueTitle }}
    |
    |
  template(v-if="pageId")
    i.fa.fa-angle-right
    |
    |
    i.fa.fa-file-o
    |
    |
    | {{ pageTitle }}
</template>

<script>
  import { mapStores } from 'pinia'
  import { useIssuesStore } from '@/stores/issues'
  import { usePagesStore } from '@/stores/pages'
  import CheckboxIcon from '@/components/shared/checkbox_icon.vue'

  export default {
    components: {
      CheckboxIcon
    },

    props: {
      placement: {
        type: Object,
        required: true
      }
    },

    async mounted() {
      const { issueId } = this
      await this.issuesStore.fetchOnce()

      if(issueId) {
        await this.pagesStore.fetchOnce({ issueId })
      }
    },

    computed: {
      ...mapStores(useIssuesStore, usePagesStore),
      publicationName() { return this.issue?.publication?.name },
      issueId() { return this.placement.issue_id },
      issue() { return this.issuesStore.forId(this.issueId) },
      issueTitle() { return this.issue?.title },
      page() { return this.pagesStore.forId(this.pageId) },
      pageId() { return this.placement.page_id },
      pageTitle() { return this.page?.title }
    }
  }
</script>
